import { Gift } from '@wix/wix-ui-icons-common';
import React from 'react';
export const GiftIcon = () => /*#__PURE__*/React.createElement(Gift, {
  size: "18",
  color: "#077842"
});
//# sourceMappingURL=GiftIcon.js.map